import { Box, Button, Card, CardHeader, Checkbox, Divider, FormControlLabel, FormGroup, Grid, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';
import { noteApiKeyStore } from '../../../api/note-api-key-store';
import { useLoadData } from '../../../hooks/useLoadData';
import { ApiResponse } from '../../../models/api-response';
import { Note } from '../../../models/note';
import { Unit } from '../../../models/unit';
import { NotesDialog } from '../../note/notes.dialog';
import { BorderBottom, Style } from '@mui/icons-material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';
import { unitsApiKeyStore } from '../../../api/units-api-key-store';
import UnitEnergyStarDetails from './unit-energy-star-details';
import { UnitHVACGradingComponent } from './unit-hvac-grading-details.component';

interface IUnitInfo {
  data: Unit;
}

const styling = {
  root: { borderRadius: '10px' },
  textColor: { color: '$primary-color' },
  headingStyle: { color: '#0000b5', paddingBottom: '10px' },
  labelStyle: { color: '#0000b5', fontSize: '14px' },
  valueStyle: { color: '#000', fontWeight: '500', fontSize: '13px' },
};

const UnitInfo = ({ data }: IUnitInfo) => {
  const [openNoteDialog, setOpenNoteDialog] = useState(false);
  const [noteTempEntityID, setNoteTempEntityID] = useState<number>();
  const {
    data: notes,
    isLoading,
    isFetching,
    refetch,
  } = useLoadData<ApiResponse<Note[]>>(noteApiKeyStore.getNotes({ unitID: data?.unitID }));

  const handleCloseNoteDialog = (tempNoteEntityID?: number) => {
    setOpenNoteDialog(false);
    if (tempNoteEntityID) {
      setNoteTempEntityID(tempNoteEntityID);
    }
  };

  const handleOpenNoteDialog = () => {
    setOpenNoteDialog(true);
  };

  // const isUATEnable = process.env.REACT_APP_UAT_FLAG === 'true';

  return (
    <>
      <Grid container spacing={2} className=" ">
        <Grid item xl={8} lg={8} sm={8} xs={8} className="detailsBox">
          <Grid container spacing={2}>
            {/* First Card */}
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <Card elevation={0}>
                <CardHeader
                  className="subHead"
                  title={
                    <div className="d-flex" style={{ justifyContent: 'space-between' }}>
                      <Typography variant="h3" color="textPrimary" style={styling.headingStyle}>
                        LOT/UNIT INFO: [&nbsp;
                        <span style={styling.headingStyle}>{!data?.unitName ? '---' : `${data?.unitName}`}</span> ]
                      </Typography>
                    </div>
                  }
                />
                <Divider sx={{ borderBottomWidth: '2px' }} />
                <Paper elevation={0} style={{ padding: 20, borderRadius: '10px' }}>
                  <Grid container>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Customer</label>
                        <span style={styling.valueStyle}>{!data?.customerName ? '---' : `${data?.customerName}`}</span>
                      </Typography>
                    </Grid>{' '}
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Office</label>
                        <span style={styling.valueStyle}>{!data?.officeName ? '---' : `${data?.officeName}`}</span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Project</label>
                        <span style={styling.valueStyle}>{!data?.projectName ? '---' : `${data?.projectName}`}</span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Project Code</label>
                        <span style={styling.valueStyle}>{!data?.projectCode ? '---' : `${data?.projectCode}`}</span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Project Type</label>
                        <span style={styling.valueStyle}>{!data?.projectType ? '---' : `${data?.projectType}`}</span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Building Name</label>
                        <span style={styling.valueStyle}>{!data?.buildingName ? '---' : `${data?.buildingName}`}</span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Community Type</label>
                        <span style={styling.valueStyle}>{!data?.communityType ? '---' : `${data?.communityType}`}</span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Floor</label>
                        <span style={styling.valueStyle}>{!data?.floor ? '---' : `${data?.floor}`}</span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Jobsite</label>
                        <span style={styling.valueStyle}>{!data?.jobsite ? '---' : `${data?.jobsite}`}</span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Lot/Unit#</label>
                        <span style={styling.valueStyle}>{!data?.unitName ? '---' : `${data?.unitName}`}</span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Address</label>
                        <span style={styling.valueStyle}>{!data?.address ? '---' : `${data?.address}`}</span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>City</label>
                        <span style={styling.valueStyle}>{!data?.city ? '---' : `${data?.city}`}</span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>State</label>
                        <span style={styling.valueStyle}>{!data?.stateName ? '---' : `${data?.stateName}`}</span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Zip Code</label>
                        <span style={styling.valueStyle}>{!data?.zip ? '---' : `${data?.zip}`}</span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>County</label>
                        <span style={styling.valueStyle}>{!data?.countyName ? '---' : `${data?.countyName}`}</span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Market Area</label>
                        <span style={styling.valueStyle}>
                          {!data?.marketAreaName ? '---' : `${data?.marketAreaName}`}
                        </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Municipality</label>
                        <span style={styling.valueStyle}>
                          {!data?.muncipalityName ? '---' : `${data?.muncipalityName}`}
                        </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Divisions</label>
                        <span style={styling.valueStyle}>{!data?.divisionName ? '---' : `${data?.divisionName}`} </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Fee Owner</label>
                        <span style={styling.valueStyle}>{!data?.feeOwner ? '---' : `${data?.feeOwner}`} </span>
                      </Typography>{' '}
                    </Grid>{' '}
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Unit Type</label>
                        <span style={styling.valueStyle}>{!data?.unitTypeText ? '---' : `${data?.unitTypeText}`} </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>FastField Service Cat</label>
                        <span style={styling.valueStyle}>{!data?.ffServiceCat ? '---' : `${data?.ffServiceCat}`} </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Builder Job Number</label>
                        <span style={styling.valueStyle}>{!data?.jobNumber ? '---' : `${data?.jobNumber}`}</span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Closing Date</label>
                        <span style={styling.valueStyle}>{!data?.closingDate ? '---' : `${data?.closingDate}`} </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Department</label>
                        <span style={styling.valueStyle}>{!data?.departmentName ? '---' : `${data?.departmentName}`} </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <FormGroup>
                        <FormControlLabel disabled control={<Checkbox checked={data?.syncWithDux == true ? true : false} />} label="Sync With Dux" />
                      </FormGroup>
                    </Grid>
                  </Grid>
                </Paper>
              </Card>
            </Grid>

            {/* Second Card */}
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <Card elevation={0}>
                <Paper elevation={0} style={{ padding: 20, borderRadius: '10px' }}>
                  <Grid container>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Building Permit#</label>
                        <span style={styling.valueStyle}>{!data?.buildingPermit ? '---' : `${data?.buildingPermit}`} </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Mechanical Permit#</label>
                        <span style={styling.valueStyle}>
                          {!data?.mechanicalPermit ? '---' : `${data?.mechanicalPermit}`}{' '}
                        </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Electrical Permit#</label>
                        <span style={styling.valueStyle}>
                          {!data?.electricalPermit ? '---' : `${data?.electricalPermit}`}{' '}
                        </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Plumbing Permit#</label>
                        <span style={styling.valueStyle}>{!data?.plumbingPermit ? '---' : `${data?.plumbingPermit}`} </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Roof Permit#</label>
                        <span style={styling.valueStyle}>{!data?.roofPermit ? '---' : `${data?.roofPermit}`} </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Irrigation Permit#</label>
                        <span style={styling.valueStyle}>
                          {!data?.irrigationPermit ? '---' : `${data?.irrigationPermit}`}{' '}
                        </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Driveway Permit#</label>
                        <span style={styling.valueStyle}>{!data?.drivewayPermit ? '---' : `${data?.drivewayPermit}`} </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Gas Permit#</label>
                        <span style={styling.valueStyle}>{!data?.gasPermit ? '---' : `${data?.gasPermit}`} </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Low Voltage Permit#</label>
                        <span style={styling.valueStyle}>{!data?.lowVoltagePermit ? '---' : `${data?.lowVoltagePermit}`} </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Application#</label>
                        <span style={styling.valueStyle}>{!data?.applicationNumber ? '---' : `${data?.applicationNumber}`} </span>
                      </Typography>{' '}
                    </Grid>

                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Parcel ID</label>
                        <span style={styling.valueStyle}>{!data?.parcelID ? '---' : `${data?.parcelID}`} </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Alternate ID</label>
                        <span style={styling.valueStyle}>{!data?.alternateID ? '---' : `${data?.alternateID}`} </span>
                      </Typography>{' '}
                    </Grid>
                    <Grid item xl={3} lg={3} sm={6} xs={6}>
                      <Typography variant="body1" color="text.secondary" className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Permit Date</label>
                        <span style={styling.valueStyle}>{!data?.permitDate ? '---' : `${data?.permitDate}`} </span>
                      </Typography>{' '}
                    </Grid>
                  </Grid>
                </Paper>
              </Card>
            </Grid>

            {/* Third Card */}
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <Card elevation={0}>
                <Paper elevation={0} style={{ padding: 20, borderRadius: '10px' }}>
                  <Grid container>
                    <Grid item xl={3} lg={3} sm={4} xs={6}>
                      <Typography className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Sq.Ft</label>
                        <span style={styling.valueStyle}>
                          {!data?.squareFeet ? '---' : `${data?.squareFeet}`}{' '}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={4} xs={6}>
                      <Typography className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Ach Area</label>
                        <span style={styling.valueStyle}>{!data?.achArea ? '---' : `${data?.achArea}`}</span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={4} xs={6}>
                      <Typography className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Volume</label>
                        <span style={styling.valueStyle}>{!data?.volume ? '---' : `${data?.volume}`}</span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={4} xs={6}>
                      <Typography className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Window Area</label>
                        <span style={styling.valueStyle}>
                          {!data?.windowArea ? '---' : `${data?.windowArea}`}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={4} xs={6}>
                      <Typography className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Registration Number</label>
                        <span style={styling.valueStyle}>
                          {!data?.registrationNumber ? '---' : `${data?.registrationNumber}`}
                        </span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={4} xs={6}>
                      <Typography className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Hers Score</label>
                        <span style={styling.valueStyle}>{!data?.hersScore ? '---' : `${data?.hersScore}`}</span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={4} xs={6}>
                      <Typography className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Rebates</label>
                        <span style={styling.valueStyle}>{!data?.rebates ? '---' : `${data?.rebates}`} </span>
                      </Typography>
                    </Grid>
                    <Grid item xl={3} lg={3} sm={4} xs={6}>
                      <Typography className="d-flex flex-column mBm">
                        <label style={styling.labelStyle}>Rebate/Utility Company</label>
                        <span style={styling.valueStyle}>
                          {!data?.rebateCompany ? '---' : `${data?.rebateCompanyName}`}{' '}
                        </span>
                      </Typography>
                    </Grid>
                  </Grid>
                </Paper>
              </Card>
            </Grid>

            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <UnitEnergyStarDetails unitData={data} />
            </Grid>
            <Grid item xl={12} lg={12} sm={12} xs={12}>
              <UnitHVACGradingComponent unitData={data} />
            </Grid>
          </Grid>
        </Grid>

        {/* ---- */}
        <Grid item xl={4} lg={4} sm={4} xs={4} className="detailsBox" style={{ marginBottom: '10px' }}>
          {/* <NavLink to="/customers" className="navLink navCustomer"> */}
          <div className="d-flex">
            <Box className="subHead2">
              <Typography variant="h3" className="primaryColor" style={{ marginBottom: '5px' }}>
                RECENT NOTES
              </Typography>
            </Box>
          </div>
          <Paper elevation={0} style={{ padding: 20, borderRadius: '10px' }}>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              style={{ maxHeight: '185px', overflowY: 'auto' }}
            >
              {notes?.data?.map((note) => (
                <div key={note?.noteID} className="recentNotes">
                  <p>
                    {note?.note}
                    <br />
                    <i>last updated: {note?.lastUpdatedOn}</i>
                  </p>
                </div>
              ))}
            </Grid>
            <GuardedComponent requiredPermissions={[UserPermissionName.VIEW_NOTE]}>
              <Button
                className="btn btn-sm btn-default btn-lightGrey btn-lightGrey-100"
                variant="text"
                onClick={handleOpenNoteDialog}
              >
                ADD NOTES
              </Button>
            </GuardedComponent>
          </Paper>
          {/* </NavLink> */}
        </Grid>
      </Grid >
      {openNoteDialog && (
        <NotesDialog
          title="UNIT"
          noteRequestArgs={{ unitID: data?.unitID }}
          open={openNoteDialog}
          onClose={handleCloseNoteDialog}
        />
      )
      }
    </>
  );
};

export default UnitInfo;
